<template>
  <div class="image-wrapper">
    <img
      :src="currentSrc"
      :alt="alt"
      class="image-with-fallback"
      @error="onError"
    />
    <img :src="currentSrc" :alt="alt" class="image-zoomed" @error="onError" />
  </div>
</template>

<script>
export default {
  name: 'ProductImageSmall',
  props: {
    src: {
      type: String,
      required: false,
      default: '',
    },
    alt: {
      type: String,
      default: 'Image',
    },
    fallbackSrc: {
      type: String,
      default: () => require('@/assets/image/no-image.png'),
    },
  },
  data() {
    return {
      currentSrc: this.src,
    };
  },
  created() {
    if (!this.src || this.src.trim() === '') {
      this.currentSrc = this.fallbackSrc;
    }
  },
  methods: {
    onError() {
      this.currentSrc = this.fallbackSrc;
    },
  },
};
</script>

<style scoped>
.image-wrapper {
  position: relative;
  display: inline-block;
  z-index: 1;
  isolation: isolate;
  cursor: pointer;
}

.image-with-fallback {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid #e9ecef;
  position: relative;
  display: block;
  background-color: white;
  z-index: 1;
}

.image-zoomed {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%) scale(1);
  opacity: 0;
  pointer-events: none;
  z-index: 99999;
  background-color: white;
  border: 2px solid #dee2e6;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    box-shadow 0.3s ease;
  transform-origin: left center;
}

.image-wrapper:hover {
  z-index: 99999 !important;
  isolation: isolate;
}

.image-wrapper:hover .image-zoomed {
  transform: translateY(-50%) scale(2.5);
  opacity: 1;
}
</style>
